import { render, staticRenderFns } from "./mpay.vue?vue&type=template&id=013ae54a"
import script from "./mpay.vue?vue&type=script&lang=js"
export * from "./mpay.vue?vue&type=script&lang=js"
import style0 from "./mpay.vue?vue&type=style&index=0&id=013ae54a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports